import { Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { CarouselResize } from '../../models/carousel-resize';

@Component({
  selector: 'app-custom-carousel',
  templateUrl: './custom-carousel.component.html',
  styleUrls: ['./custom-carousel.component.scss']
})
export class CustomCarouselComponent<T> implements OnInit {
  @Output() shareIndex = new EventEmitter<number>();
  @Input() carouselResize: CarouselResize<T> = {} as CarouselResize<T>;
  @Input() distanceBetweenControlsIndicators: boolean = false;
  @Input() distanceCenterControlsIndicators: boolean = false;
  @Input() distanceStartControlsIndicators: boolean = false;
  @Input() distanceEndControlsIndicators: boolean = false;
  @Input() showIndicators: boolean = false;
  @Input() showControls: boolean = false;
  @Input() content: TemplateRef<object>;
  slide: ReturnType<typeof setInterval>;
  
  ngOnInit(): void {
    this.carouselResize.itemResize = this.carouselResize.itemSizeLg;
    this.carouselResize.innerWidth = window.innerWidth;
    this.resizeItems();
    this.sendIndex(this.carouselResize.currentIndex);
    this.slide = setInterval(_ => {
      this.nextSlide();
    }, this.carouselResize.slideDelay);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.carouselResize.innerWidth = window.innerWidth;
    this.resizeItems();
  }
  resizeItems(): void {
    if(this.carouselResize.innerWidth >= 992){
      this.carouselResize.itemResize = this.carouselResize.itemSizeLg;
    } else if(this.carouselResize.innerWidth >= 768){
      this.carouselResize.itemResize = this.carouselResize.itemSizeMd;
    } else {
      this.carouselResize.itemResize = this.carouselResize.itemSizeSm;
    }
    this.carouselResize.items = [];
    for(let i = 0; i < this.carouselResize.data.length; i += this.carouselResize.itemResize){
      const item = this.carouselResize.data.slice(i, i + this.carouselResize.itemResize);
      this.carouselResize.items.push(item);
    }
  }
  sendIndex(index: number): void {
    this.shareIndex.emit(index);
  }
  previousSlide(): void {
    this.carouselResize.currentIndex = (--this.carouselResize.currentIndex + this.carouselResize.items.length) % this.carouselResize.items.length;
    this.sendIndex(this.carouselResize.currentIndex);
  }
  nextSlide(): void {
    this.carouselResize.currentIndex = ++this.carouselResize.currentIndex % this.carouselResize.items.length;
    this.sendIndex(this.carouselResize.currentIndex);
  }
  indicatorSlide(index: number): void {
    this.carouselResize.currentIndex = index;
    this.sendIndex(this.carouselResize.currentIndex);
  }
  ngOnDestroy(): void {
    if(this.slide) clearInterval(this.slide);
  }
}
